"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var rawTo64Bit = function (key) { return utils_1.splitByLength(utils_1.paddStartZero(key, 32), 1)
    .map(function (char) { return utils_1.decToHex(char.charCodeAt(0)); }); };
exports.default = (function (transparent48) { return function (data) {
    var frame = ['48', '45', '01', '00'];
    var _a = transparent48.virtual.device, prodKey = _a.prodKey, devTid = _a.devTid;
    frame.push.apply(frame, rawTo64Bit(prodKey));
    frame.push.apply(frame, rawTo64Bit(devTid));
    return frame;
}; });



// WEBPACK FOOTER //
// ./src/transparent48/encode/1.ts